import { countryLookup } from 'utils/lookups';

/* eslint-disable */
export const billingSegmentData: any = [
  {
    "field_map": "date",
    "item_name": "date",
    "title": "Date",
    "hint_detail": "Date",
    "hint_panel" : "Date",
    "example": "",
    "sequence": 1,
    "show_more": true,
    "lookup": null,
  },
  {
    "field_map": "invoiceNumber",
    "item_name": "invoice_number",
    "title": "Invoice no.",
    "hint_detail": "Invoice no.",
    "hint_panel" : "Invoice no.",
    "example": "",
    "sequence": 2,
    "show_more": true,
    "lookup": null,
  },
  {
    "field_map": "status",
    "item_name": "status",
    "title": "Status",
    "hint_detail": "Status",
    "hint_panel" : "Status",
    "example": "",
    "sequence": 3,
    "show_more": true,
    "lookup": null,
  },
  {
    "field_map": "details",
    "item_name": "details",
    "title": "Details",
    "hint_detail": "Details",
    "hint_panel" : "Details",
    "example": "",
    "sequence": 4,
    "show_more": true,
    "lookup": null,
  },
  {
    "field_map": "discount",
    "item_name": "discount",
    "title": "Discount",
    "hint_detail": "Discount",
    "hint_panel" : "Discount",
    "example": "",
    "sequence": 5,
    "show_more": true,
    "lookup": null,
  },
  {
    "field_map": "total",
    "item_name": "total",
    "title": "Total",
    "hint_detail": "Total",
    "hint_panel" : "Total",
    "example": "",
    "sequence": 6,
    "show_more": true,
    "lookup": null,
  },
]
/* eslint-enable */
